import React, {Component, Fragment} from 'react'
import selectedLocationsStore from './SelectedLocationsStore'
import PropTypes from 'prop-types'
import {BindWithUrl} from "../../util/BindWithUrl";
import {FieldDescriptors, FieldType} from "../../util/urlSync";

/**
 * sets the url param to the SelectedLocationsStore's selectedLocations string while mounted and not disabled.
 * Any updates to the param will also be synced to SelectedLocationsStore.selectedLocations
 */
export class BindSelectedLocationsToUrl extends Component {

  static propTypes = {
    disabled: PropTypes.bool,
    urlParamName: PropTypes.string,
    safe: PropTypes.bool
  }

  static defaultProps = {
    urlParamName: 'locationGroupId'
  }


  render() {
    return <BindWithUrl
      disabled={this.props.disabled}
      observable={selectedLocationsStore}
      fieldDescriptors={[
        FieldDescriptors.of('selectedLocations', FieldType.nonEmptyString.withUrlParamName(this.props.urlParamName))
      ]}
      safe={this.props.safe}
    />
  }
}